export const SUPPORTED_LOCALES = ['en', 'ja'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export function detectBrowserLocale(): SupportedLocale {
  const candidates = navigator.languages && navigator.languages.length
    ? navigator.languages
    : [navigator.language]

  for (const lang of candidates) {
    const short = lang.toLowerCase().split('-')[0]
    if ((SUPPORTED_LOCALES as readonly string[]).includes(short)) {
      return short as SupportedLocale
    }
  }

  return 'en'
}
